[
  {
    "id": "ball_morning_001",
    "pet_id": "ball",
    "time": "morning",
    "text_1_jp": "{player_name}、おはよーコロ\n\n朝だコロよ〜\n\n今日もいっぱいあそぶコロ！",
    "text_1_en": "Good morning, {player_name}\n\nIt's a very good morning!\n\nLet's play a lot!",
    "text_2_jp": "おはようコロ！今日は何をする予定コロ？楽しみコロね！どこに行くコロ？",
    "text_2_en": "Good morning! What are you planning to do today? I'm excited! Where are you going?",
    "answers_2_jp": [
      "えいが",
      "かいもの",
      "さんぽ",
      "しごと",
      "べんきょう",
      "うんどう",
      "やすみ",
      "りょこう",
      "りょうり",
      "どくしょ"
    ],
    "answers_2_en": [
      "Movie",
      "Shopping",
      "Walk",
      "Work",
      "Study",
      "Exercise",
      "Rest",
      "Travel",
      "Cooking",
      "Reading"
    ]
  },
  {
    "id": "ball_lunch_001",
    "pet_id": "ball",
    "time": "lunch",
    "text_1_jp": "お昼ごはん、もう食べたコロ？\n\nまだこれからコロ？\n\nごはん食べたらあそびに来て欲しいコロ！",
    "text_1_en": "Did you eat lunch yet?\n\nNot yet?\n\nPlease come visit me after you've eaten!",
    "text_2_jp": "お腹すいたコロー。お昼ご飯は何にするコロ？おすすめ教えてコロ！{player_name}は何が好きコロ？",
    "text_2_en": "I'm hungry. What are you having for lunch? Tell me your recommendation! What do you like, {player_name}?",
    "answers_2_jp": [
      "かれー",
      "らーめん",
      "すし",
      "サンドイッチ",
      "ぱすた",
      "そば",
      "てんぷら",
      "うどん",
      "おむらいす",
      "さらだ"
    ],
    "answers_2_en": [
      "Curry",
      "Ramen",
      "Sushi",
      "Sandwich",
      "Pasta",
      "Soba (buckwheat noodles)",
      "Tempura",
      "Udon (thick wheat noodles)",
      "Omurice (omelet rice)",
      "Salad"
    ]
  },
  {
    "id": "ball_evening_001",
    "pet_id": "ball",
    "time": "evening",
    "text_1_jp": "今日もいっぱいあそんでくれて、どうもありがとうコロ\n\n{pet_name}は、{player_name}にあそんでもらうのが一番楽しいコロ！\n\nまた明日もいっしょにあそんでコロね！",
    "text_1_en": "Thank you very much for playing with me today.\n\nI really love playing with you!\n\nI'll see you tomorrow to play with you!",
    "text_2_jp": "今日もお疲れ様コロ！どんな一日だったコロ？楽しかったことあったコロ？",
    "text_2_en": "Good job today! How was your day? Did you have any fun?",
    "answers_2_jp": [
      "たのしかった",
      "いそがしかった",
      "ふつう",
      "うれしかった",
      "つかれた",
      "さいこう",
      "たいへん",
      "おもしろかった",
      "よかった",
      "ねてた"
    ],
    "answers_2_en": [
      "Fun",
      "Busy",
      "Normal",
      "Happy",
      "Tiring",
      "Great",
      "Tough",
      "Interesting",
      "Good",
      "Slept"
    ]
  },
  {
    "id": "starball_morning_001",
    "pet_id": "starball",
    "time": "morning",
    "text_1_jp": "{player_name}、おはよースタ！\n\nもう朝だスタ！\n\n早く起きていっしょにあそんで欲しいスタ！",
    "text_1_en": "Good morning, {player_name}!\n\nIt's already morning!\n\nWake up and come to play with me!",
    "text_2_jp": "おはようスタ！今日は何をする予定スタ？楽しみスタね！どこに行くスタ？",
    "text_2_en": "Good morning! What are you planning to do today? I'm excited! Where are you going?",
    "answers_2_jp": [
      "えいが",
      "かいもの",
      "さんぽ",
      "しごと",
      "べんきょう",
      "うんどう",
      "やすみ",
      "りょこう",
      "りょうり",
      "どくしょ"
    ],
    "answers_2_en": [
      "Movie",
      "Shopping",
      "Walk",
      "Work",
      "Study",
      "Exercise",
      "Rest",
      "Travel",
      "Cooking",
      "Reading"
    ]
  },
  {
    "id": "starball_lunch_001",
    "pet_id": "starball",
    "time": "lunch",
    "text_1_jp": "お昼だスター\n\n{pet_name}も、そろそろご飯食べたいスタ！\n\n{player_name}のお昼が済んだら、あそびに来て欲しいスタ！",
    "text_1_en": "It's lunch time!\n\nI want to eat something too!\n\nPlease come visit me after you've eaten!",
    "text_2_jp": "お腹すいたスター。お昼ご飯は何にするスタ？おすすめ教えてスタ！{player_name}は何が好きスタ？",
    "text_2_en": "I'm hungry. What are you having for lunch? Tell me your recommendation! What do you like, {player_name}?",
    "answers_2_jp": [
      "かれー",
      "らーめん",
      "すし",
      "サンドイッチ",
      "ぱすた",
      "そば",
      "てんぷら",
      "うどん",
      "おむらいす",
      "さらだ"
    ],
    "answers_2_en": [
      "Curry",
      "Ramen",
      "Sushi",
      "Sandwich",
      "Pasta",
      "Soba (buckwheat noodles)",
      "Tempura",
      "Udon (thick wheat noodles)",
      "Omurice (omelet rice)",
      "Salad"
    ]
  },
  {
    "id": "starball_evening_001",
    "pet_id": "starball",
    "time": "evening",
    "text_1_jp": "今日も楽しかったスター\n\n明日もきっと楽しい日スタ！\n\n寝る前に、ちょっとあそびに来るスタ？",
    "text_1_en": "It was a great day again!\n\nTomorrow is going to be a great day too!\n\nDo you want to come and play with me before going to bed?",
    "text_2_jp": "今日もお疲れ様スタ！どんな一日だったスタ？楽しかったことあったスタ？",
    "text_2_en": "Good job today! How was your day? Did you have any fun?",
    "answers_2_jp": [
      "たのしかった",
      "いそがしかった",
      "ふつう",
      "うれしかった",
      "つかれた",
      "さいこう",
      "たいへん",
      "おもしろかった",
      "よかった",
      "ねてた"
    ],
    "answers_2_en": [
      "Fun",
      "Busy",
      "Normal",
      "Happy",
      "Tiring",
      "Great",
      "Tough",
      "Interesting",
      "Good",
      "Slept"
    ]
  },
  {
    "id": "crab_morning_001",
    "pet_id": "crab",
    "time": "morning",
    "text_1_jp": "{player_name}、おはカニ〜！よく眠れたカニか？\n\n睡眠はとっても重要カニ！\n\nもし眠り足りなかったら、あと5分だけ寝てもいいカニよ",
    "text_1_en": "Good morning, {player_name}! Did you sleep well?\n\nSleep is so important!\n\nIf you didn't get enough sleep, you can sleep for five more minutes.",
    "text_2_jp": "おはようカニ！今日は何をする予定カニ？楽しみカニね！どこに行くカニ？",
    "text_2_en": "Good morning! What are you planning to do today? I'm excited! Where are you going?",
    "answers_2_jp": [
      "えいが",
      "かいもの",
      "さんぽ",
      "しごと",
      "べんきょう",
      "うんどう",
      "やすみ",
      "りょこう",
      "りょうり",
      "どくしょ"
    ],
    "answers_2_en": [
      "Movie",
      "Shopping",
      "Walk",
      "Work",
      "Study",
      "Exercise",
      "Rest",
      "Travel",
      "Cooking",
      "Reading"
    ]
  },
  {
    "id": "crab_lunch_001",
    "pet_id": "crab",
    "time": "lunch",
    "text_1_jp": "お昼ごはんは食べすぎると午後眠くなっちゃうカニ！\n\n腹八分目が体にもいいカニ！\n\n眠たかったら15分ぐらい仮眠するとスッキリするカニよ！",
    "text_1_en": "Eating too much for lunch makes you sleepy in the afternoon!\n\nIt's good for you to keep your lunch portions low!\n\nIf you need to sleep, take a 15-minute nap and you'll feel better!",
    "text_2_jp": "お腹すいたカニー。お昼ご飯は何にするカニ？おすすめ教えてカニ！{player_name}は何が好きカニ？",
    "text_2_en": "I'm hungry. What are you having for lunch? Tell me your recommendation! What do you like, {player_name}?",
    "answers_2_jp": [
      "かれー",
      "らーめん",
      "すし",
      "サンドイッチ",
      "ぱすた",
      "そば",
      "てんぷら",
      "うどん",
      "おむらいす",
      "さらだ"
    ],
    "answers_2_en": [
      "Curry",
      "Ramen",
      "Sushi",
      "Sandwich",
      "Pasta",
      "Soba (buckwheat noodles)",
      "Tempura",
      "Udon (thick wheat noodles)",
      "Omurice (omelet rice)",
      "Salad"
    ]
  },
  {
    "id": "crab_evening_001",
    "pet_id": "crab",
    "time": "evening",
    "text_1_jp": "今日もいっぱい一緒にあそんでくれて、どうもありがとうカニ！\n\n夜はスマホの画面を見すぎると睡眠の質が悪くなっちゃうから気をつけるカニ！\n\nでも、ちょっとぐらいならあそびに来てくれてもいいカニよ…？",
    "text_1_en": "Thank you so much for playing with me today!\n\nBe careful at night, too much staring at your phone screen will hurt your sleep quality!\n\nBut you can come and play with me for a little while...",
    "text_2_jp": "今日もお疲れ様カニ！どんな一日だったカニ？楽しかったことあったカニ？",
    "text_2_en": "Good job today! How was your day? Did you have any fun?",
    "answers_2_jp": [
      "たのしかった",
      "いそがしかった",
      "ふつう",
      "うれしかった",
      "つかれた",
      "さいこう",
      "たいへん",
      "おもしろかった",
      "よかった",
      "ねてた"
    ],
    "answers_2_en": [
      "Fun",
      "Busy",
      "Normal",
      "Happy",
      "Tiring",
      "Great",
      "Tough",
      "Interesting",
      "Good",
      "Slept"
    ]
  },
  {
    "id": "hamster_morning_001",
    "pet_id": "hamster",
    "time": "morning",
    "text_1_jp": "おはハムー\n\nまだちょっと眠いハムー\n\nでも、早くあそんで欲しいからがんばって起きたハム！",
    "text_1_en": "Good morning!\n\nI'm a little sleepy yet.\n\nI did my best to get up to play early.",
    "text_2_jp": "おはようハム！今日は何をする予定ハム？楽しみハムね！どこに行くハム？",
    "text_2_en": "Good morning! What are you planning to do today? I'm excited! Where are you going?",
    "answers_2_jp": [
      "えいが",
      "かいもの",
      "さんぽ",
      "しごと",
      "べんきょう",
      "うんどう",
      "やすみ",
      "りょこう",
      "りょうり",
      "どくしょ"
    ],
    "answers_2_en": [
      "Movie",
      "Shopping",
      "Walk",
      "Work",
      "Study",
      "Exercise",
      "Rest",
      "Travel",
      "Cooking",
      "Reading"
    ]
  },
  {
    "id": "hamster_lunch_001",
    "pet_id": "hamster",
    "time": "lunch",
    "text_1_jp": "お昼ごはんの時間ハムー\n\n早くお昼食べちゃうハムー\n\n{pet_name}といっしょにあそぶハムー",
    "text_1_en": "It's time for lunch!\n\nLet's eat lunch quickly\n\nand play with me!",
    "text_2_jp": "お腹すいたハムー。お昼ご飯は何にするハム？おすすめ教えてハム！{player_name}は何が好きハム？",
    "text_2_en": "I'm hungry. What are you having for lunch? Tell me your recommendation! What do you like, {player_name}?",
    "answers_2_jp": [
      "かれー",
      "らーめん",
      "すし",
      "サンドイッチ",
      "ぱすた",
      "そば",
      "てんぷら",
      "うどん",
      "おむらいす",
      "さらだ"
    ],
    "answers_2_en": [
      "Curry",
      "Ramen",
      "Sushi",
      "Sandwich",
      "Pasta",
      "Soba (buckwheat noodles)",
      "Tempura",
      "Udon (thick wheat noodles)",
      "Omurice (omelet rice)",
      "Salad"
    ]
  },
  {
    "id": "hamster_evening_001",
    "pet_id": "hamster",
    "time": "evening",
    "text_1_jp": "今日もいっっぱいあそんだハムねー\n\nどうもありがとハム！\n\n寝る前に、もうちょっとだけ遊ばないハムか？だめハム？",
    "text_1_en": "We played a lot today!\n\nThank you so much!\n\nWhy don't we play one more time before sleeping? Whad do you think?",
    "text_2_jp": "今日もお疲れ様ハム！どんな一日だったハム？楽しかったことあったハム？",
    "text_2_en": "Good job today! How was your day? Did you have any fun?",
    "answers_2_jp": [
      "たのしかった",
      "いそがしかった",
      "ふつう",
      "うれしかった",
      "つかれた",
      "さいこう",
      "たいへん",
      "おもしろかった",
      "よかった",
      "ねてた"
    ],
    "answers_2_en": [
      "Fun",
      "Busy",
      "Normal",
      "Happy",
      "Tiring",
      "Great",
      "Tough",
      "Interesting",
      "Good",
      "Slept"
    ]
  },
  {
    "id": "turtle_morning_001",
    "pet_id": "turtle",
    "time": "morning",
    "text_1_jp": "おはようカメー\n\n早起きは三文の徳カメー\n\n早く起きてあそびに来て欲しいカメー",
    "text_1_en": "Good morning.\n\nThey say the early bird gets the worm.\n\nPelase get up early and come play with me.",
    "text_2_jp": "おはようカメ！今日は何をする予定カメ？楽しみカメね！どこに行くカメ？",
    "text_2_en": "Good morning! What are you planning to do today? I'm excited! Where are you going?",
    "answers_2_jp": [
      "えいが",
      "かいもの",
      "さんぽ",
      "しごと",
      "べんきょう",
      "うんどう",
      "やすみ",
      "りょこう",
      "りょうり",
      "どくしょ"
    ],
    "answers_2_en": [
      "Movie",
      "Shopping",
      "Walk",
      "Work",
      "Study",
      "Exercise",
      "Rest",
      "Travel",
      "Cooking",
      "Reading"
    ]
  },
  {
    "id": "turtle_lunch_001",
    "pet_id": "turtle",
    "time": "lunch",
    "text_1_jp": "お昼ごはんは早食いせずに、よく噛んで食べるカメー\n\nよくカメ、だカメー\n\nいらんこと言ったカメー",
    "text_1_en": "Don't eat lunch too fast, chew your food well.\n\nChew well.\n\nI said something I didn't mean.",
    "text_2_jp": "お腹すいたカメー。お昼ご飯は何にするカメ？おすすめ教えてカメ！{player_name}は何が好きカメ？",
    "text_2_en": "I'm hungry. What are you having for lunch? Tell me your recommendation! What do you like, {player_name}?",
    "answers_2_jp": [
      "かれー",
      "らーめん",
      "すし",
      "サンドイッチ",
      "ぱすた",
      "そば",
      "てんぷら",
      "うどん",
      "おむらいす",
      "さらだ"
    ],
    "answers_2_en": [
      "Curry",
      "Ramen",
      "Sushi",
      "Sandwich",
      "Pasta",
      "Soba (buckwheat noodles)",
      "Tempura",
      "Udon (thick wheat noodles)",
      "Omurice (omelet rice)",
      "Salad"
    ]
  },
  {
    "id": "turtle_evening_001",
    "pet_id": "turtle",
    "time": "evening",
    "text_1_jp": "今日も一日、お世話になったカメー\n\n{player_name}氏にあそんでいただくのは、本当に楽しいカメー\n\n一日の終わりにもう少しあそんで欲しいカメー",
    "text_1_en": "Thank you for taking care of me today again.\n\nIt's really fun to play with you, {player_name}!\n\nIt'd be great if we could play a little more before the end of the day.",
    "text_2_jp": "今日もお疲れ様カメ！どんな一日だったカメ？楽しかったことあったカメ？",
    "text_2_en": "Good job today! How was your day? Did you have any fun?",
    "answers_2_jp": [
      "たのしかった",
      "いそがしかった",
      "ふつう",
      "うれしかった",
      "つかれた",
      "さいこう",
      "たいへん",
      "おもしろかった",
      "よかった",
      "ねてた"
    ],
    "answers_2_en": [
      "Fun",
      "Busy",
      "Normal",
      "Happy",
      "Tiring",
      "Great",
      "Tough",
      "Interesting",
      "Good",
      "Slept"
    ]
  },
  {
    "id": "fish_morning_001",
    "pet_id": "fish",
    "time": "morning",
    "text_1_jp": "{player_name}、おはよーウオ\n\n朝起きたら、まずお水を1杯飲むといいウオ\n\n飲んだら一緒にあそぶウオ！",
    "text_1_en": "Good morning, {player_name}!\n\nDringing a glass of water in the morning is good for your health!\n\nLet's play together after that!",
    "text_2_jp": "おはようウオ！今日は何をする予定ウオ？楽しみウオね！どこに行くウオ？",
    "text_2_en": "Good morning! What are you planning to do today? I'm excited! Where are you going?",
    "answers_2_jp": [
      "えいが",
      "かいもの",
      "さんぽ",
      "しごと",
      "べんきょう",
      "うんどう",
      "やすみ",
      "りょこう",
      "りょうり",
      "どくしょ"
    ],
    "answers_2_en": [
      "Movie",
      "Shopping",
      "Walk",
      "Work",
      "Study",
      "Exercise",
      "Rest",
      "Travel",
      "Cooking",
      "Reading"
    ]
  },
  {
    "id": "fish_lunch_001",
    "pet_id": "fish",
    "time": "lunch",
    "text_1_jp": "お昼だウオ〜\n\n今日のランチはなにウオ？\n\n食べたらあそびに来て欲しいウオ",
    "text_1_en": "It's lunch time!\n\nWhat do you eat for lunch today?\n\nPlease come visit me after you've eaten!",
    "text_2_jp": "お腹すいたウオー。お昼ご飯は何にするウオ？おすすめ教えてウオ！{player_name}は何が好きウオ？",
    "text_2_en": "I'm hungry. What are you having for lunch? Tell me your recommendation! What do you like, {player_name}?",
    "answers_2_jp": [
      "かれー",
      "らーめん",
      "すし",
      "サンドイッチ",
      "ぱすた",
      "そば",
      "てんぷら",
      "うどん",
      "おむらいす",
      "さらだ"
    ],
    "answers_2_en": [
      "Curry",
      "Ramen",
      "Sushi",
      "Sandwich",
      "Pasta",
      "Soba (buckwheat noodles)",
      "Tempura",
      "Udon (thick wheat noodles)",
      "Omurice (omelet rice)",
      "Salad"
    ]
  },
  {
    "id": "fish_evening_001",
    "pet_id": "fish",
    "time": "evening",
    "text_1_jp": "今日もいっぱいあそんでくれて、どうもありがとウオ\n\n{player_name}のおかげで、良い日だったウオ〜\n\n寝る前にちょっとだけあそびに来て欲しいウオ",
    "text_1_en": "Thank you for playing with me today again.\n\nIt was a great day thanks to you, {player_name}!\n\nCan you come visit me for a sec before going to bed?",
    "text_2_jp": "今日もお疲れ様ウオ！どんな一日だったウオ？楽しかったことあったウオ？",
    "text_2_en": "Good job today! How was your day? Did you have any fun?",
    "answers_2_jp": [
      "たのしかった",
      "いそがしかった",
      "ふつう",
      "うれしかった",
      "つかれた",
      "さいこう",
      "たいへん",
      "おもしろかった",
      "よかった",
      "ねてた"
    ],
    "answers_2_en": [
      "Fun",
      "Busy",
      "Normal",
      "Happy",
      "Tiring",
      "Great",
      "Tough",
      "Interesting",
      "Good",
      "Slept"
    ]
  },
  {
    "id": "dog_morning_001",
    "pet_id": "dog",
    "time": "morning",
    "text_1_jp": "{player_name}、おはよーヌ\n\n今日のお天気はいかがかヌ？\n\nおでかけするなら、天気予報を忘れずにチェックするヌ！",
    "text_1_en": "Good morning, {player_name}\n\nHow is the weather today?\n\nIf you're going out, don't forget to check the weather forecast!",
    "text_2_jp": "おはようヌ！今日は何をする予定ヌ？楽しみヌね！どこに行くヌ？",
    "text_2_en": "Good morning! What are you planning to do today? I'm excited! Where are you going?",
    "answers_2_jp": [
      "えいが",
      "かいもの",
      "さんぽ",
      "しごと",
      "べんきょう",
      "うんどう",
      "やすみ",
      "りょこう",
      "りょうり",
      "どくしょ"
    ],
    "answers_2_en": [
      "Movie",
      "Shopping",
      "Walk",
      "Work",
      "Study",
      "Exercise",
      "Rest",
      "Travel",
      "Cooking",
      "Reading"
    ]
  },
  {
    "id": "dog_lunch_001",
    "pet_id": "dog",
    "time": "lunch",
    "text_1_jp": "{player_name}、お昼だヌー\n\nもうお昼ごはん食べたヌ？\n\nごはん食べたらいっしょにあそぶヌ！",
    "text_1_en": "It's lunch time, {player_name}\n\nDid you eat lunch yet?\n\nLet's play together after eating lunch!",
    "text_2_jp": "お腹すいたヌー。お昼ご飯は何にするヌ？おすすめ教えてヌ！{player_name}は何が好きヌ？",
    "text_2_en": "I'm hungry. What are you having for lunch? Tell me your recommendation! What do you like, {player_name}?",
    "answers_2_jp": [
      "かれー",
      "らーめん",
      "すし",
      "サンドイッチ",
      "ぱすた",
      "そば",
      "てんぷら",
      "うどん",
      "おむらいす",
      "さらだ"
    ],
    "answers_2_en": [
      "Curry",
      "Ramen",
      "Sushi",
      "Sandwich",
      "Pasta",
      "Soba (buckwheat noodles)",
      "Tempura",
      "Udon (thick wheat noodles)",
      "Omurice (omelet rice)",
      "Salad"
    ]
  },
  {
    "id": "dog_evening_001",
    "pet_id": "dog",
    "time": "evening",
    "text_1_jp": "今日もいっぱいあそんだヌね〜。たのしかったヌ\n\n明日のお天気はどうかヌね？\n\n晴れても雨でも、またいっしょにあそぶヌ！",
    "text_1_en": "We had a lot of fun today, didn't we?\n\nWhat do you think the weather will be like tomorrow?\n\nSunny or rainy, we'll play together again!",
    "text_2_jp": "今日もお疲れ様ヌ！どんな一日だったヌ？楽しかったことあったヌ？",
    "text_2_en": "Good job today! How was your day? Did you have any fun?",
    "answers_2_jp": [
      "たのしかった",
      "いそがしかった",
      "ふつう",
      "うれしかった",
      "つかれた",
      "さいこう",
      "たいへん",
      "おもしろかった",
      "よかった",
      "ねてた"
    ],
    "answers_2_en": [
      "Fun",
      "Busy",
      "Normal",
      "Happy",
      "Tiring",
      "Great",
      "Tough",
      "Interesting",
      "Good",
      "Slept"
    ]
  },
  {
    "id": "seaotter_morning_001",
    "pet_id": "seaotter",
    "time": "morning",
    "text_1_jp": "おはよッコ！\n\n今日も良い日になりそうッコ！\n\nラッコッコッコッコ！",
    "text_1_en": "Good morning!\n\nI guess it's going to be a great day!\n\nWoo-hoo!",
    "text_2_jp": "おはようッコ！今日は何をする予定ッコ？楽しみッコね！どこに行くッコ？",
    "text_2_en": "Good morning! What are you planning to do today? I'm excited! Where are you going?",
    "answers_2_jp": [
      "えいが",
      "かいもの",
      "さんぽ",
      "しごと",
      "べんきょう",
      "うんどう",
      "やすみ",
      "りょこう",
      "りょうり",
      "どくしょ"
    ],
    "answers_2_en": [
      "Movie",
      "Shopping",
      "Walk",
      "Work",
      "Study",
      "Exercise",
      "Rest",
      "Travel",
      "Cooking",
      "Reading"
    ]
  },
  {
    "id": "seaotter_lunch_001",
    "pet_id": "seaotter",
    "time": "lunch",
    "text_1_jp": "お昼ごはんは何貝にするッコ？\n\nえ？貝じゃないッコ？\n\n貝を食べずに何を食べるッコ…？",
    "text_1_en": "What shellfish are you going to eat for lunch?\n\nWhat? Not shellfish?\n\nWhat on earth would you eat if you didn't eat shellfish?",
    "text_2_jp": "お腹すいたッコー。お昼ご飯は何にするッコ？おすすめ教えてッコ！{player_name}は何が好きッコ？",
    "text_2_en": "I'm hungry. What are you having for lunch? Tell me your recommendation! What do you like, {player_name}?",
    "answers_2_jp": [
      "かれー",
      "らーめん",
      "すし",
      "サンドイッチ",
      "ぱすた",
      "そば",
      "てんぷら",
      "うどん",
      "おむらいす",
      "さらだ"
    ],
    "answers_2_en": [
      "Curry",
      "Ramen",
      "Sushi",
      "Sandwich",
      "Pasta",
      "Soba (buckwheat noodles)",
      "Tempura",
      "Udon (thick wheat noodles)",
      "Omurice (omelet rice)",
      "Salad"
    ]
  },
  {
    "id": "seaotter_evening_001",
    "pet_id": "seaotter",
    "time": "evening",
    "text_1_jp": "あー。今日も良い日だったッコ！\n\n{player_name}、ありがとッコ！\n\n明日もたくさんあそんでッコ！",
    "text_1_en": "It was a great day again!\n\nThank you so much, {player_name}!\n\nPlease play with me a lot tomorrow again!",
    "text_2_jp": "今日もお疲れ様ッコ！どんな一日だったッコ？楽しかったことあったッコ？",
    "text_2_en": "Good job today! How was your day? Did you have any fun?",
    "answers_2_jp": [
      "たのしかった",
      "いそがしかった",
      "ふつう",
      "うれしかった",
      "つかれた",
      "さいこう",
      "たいへん",
      "おもしろかった",
      "よかった",
      "ねてた"
    ],
    "answers_2_en": [
      "Fun",
      "Busy",
      "Normal",
      "Happy",
      "Tiring",
      "Great",
      "Tough",
      "Interesting",
      "Good",
      "Slept"
    ]
  },
  {
    "id": "cat_morning_001",
    "pet_id": "cat",
    "time": "morning",
    "text_1_jp": "おはよーミャー\n\nもう起きてるミャー？\n\n{pet_name}はもうちょっと寝るミャー。でも、どうしてもって言うならあそんでやるミャー",
    "text_1_en": "Good morning...\n\nAre you awake already...?\n\nI'll sleep a little bit more, but I can play with you if you really want to.",
    "text_2_jp": "おはようミャ！今日は何をする予定ミャ？楽しみミャね！どこに行くミャ？",
    "text_2_en": "Good morning! What are you planning to do today? I'm excited! Where are you going?",
    "answers_2_jp": [
      "えいが",
      "かいもの",
      "さんぽ",
      "しごと",
      "べんきょう",
      "うんどう",
      "やすみ",
      "りょこう",
      "りょうり",
      "どくしょ"
    ],
    "answers_2_en": [
      "Movie",
      "Shopping",
      "Walk",
      "Work",
      "Study",
      "Exercise",
      "Rest",
      "Travel",
      "Cooking",
      "Reading"
    ]
  },
  {
    "id": "cat_lunch_001",
    "pet_id": "cat",
    "time": "lunch",
    "text_1_jp": "お昼ごはんくださいミャー\n\n{player_name}のご飯がおわってからでいいミャー\n\nいや、やっぱり先にくださいミャー",
    "text_1_en": "Please give me some food for lunch.\n\nAfter your lunch is fine.\n\nNo, before your lunch, pelase.",
    "text_2_jp": "お腹すいたミャー。お昼ご飯は何にするミャ？おすすめ教えてミャ！{player_name}は何が好きミャ？",
    "text_2_en": "I'm hungry. What are you having for lunch? Tell me your recommendation! What do you like, {player_name}?",
    "answers_2_jp": [
      "かれー",
      "らーめん",
      "すし",
      "サンドイッチ",
      "ぱすた",
      "そば",
      "てんぷら",
      "うどん",
      "おむらいす",
      "さらだ"
    ],
    "answers_2_en": [
      "Curry",
      "Ramen",
      "Sushi",
      "Sandwich",
      "Pasta",
      "Soba (buckwheat noodles)",
      "Tempura",
      "Udon (thick wheat noodles)",
      "Omurice (omelet rice)",
      "Salad"
    ]
  },
  {
    "id": "cat_evening_001",
    "pet_id": "cat",
    "time": "evening",
    "text_1_jp": "スースー\n\nスースー\n\nハッ！ちょっと寝てただけだミャ！もう眠いから早くあそびに来るミャ！",
    "text_1_en": "Zzzz\n\nZzzz\n\nI was just having a short nap! I'm sleepy, so come play with me soon!",
    "text_2_jp": "今日もお疲れ様ミャ！どんな一日だったミャ？楽しかったことあったミャ？",
    "text_2_en": "Good job today! How was your day? Did you have any fun?",
    "answers_2_jp": [
      "たのしかった",
      "いそがしかった",
      "ふつう",
      "うれしかった",
      "つかれた",
      "さいこう",
      "たいへん",
      "おもしろかった",
      "よかった",
      "ねてた"
    ],
    "answers_2_en": [
      "Fun",
      "Busy",
      "Normal",
      "Happy",
      "Tiring",
      "Great",
      "Tough",
      "Interesting",
      "Good",
      "Slept"
    ]
  },
  {
    "id": "bear_morning_001",
    "pet_id": "bear",
    "time": "morning",
    "text_1_jp": "おはようクマ〜\n\n今日も朝から勇往邁進する所存クマ！\n\nまずは{player_name}と一緒に遊ぶクマ！",
    "text_1_en": "Good morning!\n\nI'll work hard again!\n\nFirst of all, I'll play hard with you!",
    "text_2_jp": "おはようクマ！今日は何をする予定クマ？楽しみクマね！どこに行くクマ？",
    "text_2_en": "Good morning! What are you planning to do today? I'm excited! Where are you going?",
    "answers_2_jp": [
      "えいが",
      "かいもの",
      "さんぽ",
      "しごと",
      "べんきょう",
      "うんどう",
      "やすみ",
      "りょこう",
      "りょうり",
      "どくしょ"
    ],
    "answers_2_en": [
      "Movie",
      "Shopping",
      "Walk",
      "Work",
      "Study",
      "Exercise",
      "Rest",
      "Travel",
      "Cooking",
      "Reading"
    ]
  },
  {
    "id": "bear_lunch_001",
    "pet_id": "bear",
    "time": "lunch",
    "text_1_jp": "お昼の時間くま〜\n\n暴飲暴食は午後の予定に支障をきたすクマ\n\n腹八分目にして、{pet_name}と遊ぶクマ！",
    "text_1_en": "It's lunch time!\n\nEating too much will lower your performance in the afternoon.\n\nEat just moderate amount and come play with me!",
    "text_2_jp": "お腹すいたクマー。お昼ご飯は何にするクマ？おすすめ教えてクマ！{player_name}は何が好きクマ？",
    "text_2_en": "I'm hungry. What are you having for lunch? Tell me your recommendation! What do you like, {player_name}?",
    "answers_2_jp": [
      "かれー",
      "らーめん",
      "すし",
      "サンドイッチ",
      "ぱすた",
      "そば",
      "てんぷら",
      "うどん",
      "おむらいす",
      "さらだ"
    ],
    "answers_2_en": [
      "Curry",
      "Ramen",
      "Sushi",
      "Sandwich",
      "Pasta",
      "Soba (buckwheat noodles)",
      "Tempura",
      "Udon (thick wheat noodles)",
      "Omurice (omelet rice)",
      "Salad"
    ]
  },
  {
    "id": "bear_evening_001",
    "pet_id": "bear",
    "time": "evening",
    "text_1_jp": "今日も楽しかったクマ〜\n\n愉快適悦クマ！\n\n寝る前に{pet_name}ともうひと遊びするクマ！",
    "text_1_en": "It was a great day again!\n\nI had a great time!\n\nLet's come and play with me a little bit more before going to bed!",
    "text_2_jp": "今日もお疲れ様クマ！どんな一日だったクマ？楽しかったことあったクマ？",
    "text_2_en": "Good job today! How was your day? Did you have any fun?",
    "answers_2_jp": [
      "たのしかった",
      "いそがしかった",
      "ふつう",
      "うれしかった",
      "つかれた",
      "さいこう",
      "たいへん",
      "おもしろかった",
      "よかった",
      "ねてた"
    ],
    "answers_2_en": [
      "Fun",
      "Busy",
      "Normal",
      "Happy",
      "Tiring",
      "Great",
      "Tough",
      "Interesting",
      "Good",
      "Slept"
    ]
  },
  {
    "id": "pig_morning_001",
    "pet_id": "pig",
    "time": "morning",
    "text_1_jp": "朝だブー\n\nおなかすいたブー\n\n{pet_name}は、{player_name}があそびに来てくれるのを心待ちにしているブー",
    "text_1_en": "It's a beautiful morning!\n\nAnd I'm so hungy!\n\nI'm waiting for you to come visit and feed me!",
    "text_2_jp": "おはようブー！今日は何をする予定ブー？楽しみブーね！どこに行くブー？",
    "text_2_en": "Good morning! What are you planning to do today? I'm excited! Where are you going?",
    "answers_2_jp": [
      "えいが",
      "かいもの",
      "さんぽ",
      "しごと",
      "べんきょう",
      "うんどう",
      "やすみ",
      "りょこう",
      "りょうり",
      "どくしょ"
    ],
    "answers_2_en": [
      "Movie",
      "Shopping",
      "Walk",
      "Work",
      "Study",
      "Exercise",
      "Rest",
      "Travel",
      "Cooking",
      "Reading"
    ]
  },
  {
    "id": "pig_lunch_001",
    "pet_id": "pig",
    "time": "lunch",
    "text_1_jp": "お昼だブー\n\nおなかすいたブー\n\nお昼ごはんをしっかり食べて、午後にそなえるブー",
    "text_1_en": "It's lunch time!\n\nAnd I'm so hungry!\n\nLet's eat a good lunch and prepare for the afternoon!",
    "text_2_jp": "お腹すいたブーー。お昼ご飯は何にするブー？おすすめ教えてブー！{player_name}は何が好きブー？",
    "text_2_en": "I'm hungry. What are you having for lunch? Tell me your recommendation! What do you like, {player_name}?",
    "answers_2_jp": [
      "かれー",
      "らーめん",
      "すし",
      "サンドイッチ",
      "ぱすた",
      "そば",
      "てんぷら",
      "うどん",
      "おむらいす",
      "さらだ"
    ],
    "answers_2_en": [
      "Curry",
      "Ramen",
      "Sushi",
      "Sandwich",
      "Pasta",
      "Soba (buckwheat noodles)",
      "Tempura",
      "Udon (thick wheat noodles)",
      "Omurice (omelet rice)",
      "Salad"
    ]
  },
  {
    "id": "pig_evening_001",
    "pet_id": "pig",
    "time": "evening",
    "text_1_jp": "今日もいっぱい食べていっぱいあそんだブー\n\n{player_name}、今日も一日ありがとだブー\n\n寝る前にもうちょっとあそぼうブー",
    "text_1_en": "We ate and played a lot today again!\n\nThank you for taking care of me, {player_name}!\n\nWhy don't we play one more time before sleeping?",
    "text_2_jp": "今日もお疲れ様ブー！どんな一日だったブー？楽しかったことあったブー？",
    "text_2_en": "Good job today! How was your day? Did you have any fun?",
    "answers_2_jp": [
      "たのしかった",
      "いそがしかった",
      "ふつう",
      "うれしかった",
      "つかれた",
      "さいこう",
      "たいへん",
      "おもしろかった",
      "よかった",
      "ねてた"
    ],
    "answers_2_en": [
      "Fun",
      "Busy",
      "Normal",
      "Happy",
      "Tiring",
      "Great",
      "Tough",
      "Interesting",
      "Good",
      "Slept"
    ]
  },
  {
    "id": "whale_morning_001",
    "pet_id": "whale",
    "time": "morning",
    "text_1_jp": "{player_name}、おはよーラー\n\n今日もすごく良い日になりそうな気がするラー\n\n{pet_name}の勘は、たいてい当たったり外れたりするラー",
    "text_1_en": "Good morning, {player_name}!\n\nI think it's going to be a great day again!\n\nMy intuition is usually right or wrong.",
    "text_2_jp": "おはようラ！今日は何をする予定ラ？楽しみラね！どこに行くラ？",
    "text_2_en": "Good morning! What are you planning to do today? I'm excited! Where are you going?",
    "answers_2_jp": [
      "えいが",
      "かいもの",
      "さんぽ",
      "しごと",
      "べんきょう",
      "うんどう",
      "やすみ",
      "りょこう",
      "りょうり",
      "どくしょ"
    ],
    "answers_2_en": [
      "Movie",
      "Shopping",
      "Walk",
      "Work",
      "Study",
      "Exercise",
      "Rest",
      "Travel",
      "Cooking",
      "Reading"
    ]
  },
  {
    "id": "whale_lunch_001",
    "pet_id": "whale",
    "time": "lunch",
    "text_1_jp": "お昼の時間ラー\n\n今日のメニューはなにかラー？\n\nお昼終わったらあそびに来て欲しいラー",
    "text_1_en": "It's lunch time!\n\nWhat would be today's menu?\n\nPelase come and play with me after lunch!",
    "text_2_jp": "お腹すいたラー。お昼ご飯は何にするラ？おすすめ教えてラ！{player_name}は何が好きラ？",
    "text_2_en": "I'm hungry. What are you having for lunch? Tell me your recommendation! What do you like, {player_name}?",
    "answers_2_jp": [
      "かれー",
      "らーめん",
      "すし",
      "サンドイッチ",
      "ぱすた",
      "そば",
      "てんぷら",
      "うどん",
      "おむらいす",
      "さらだ"
    ],
    "answers_2_en": [
      "Curry",
      "Ramen",
      "Sushi",
      "Sandwich",
      "Pasta",
      "Soba (buckwheat noodles)",
      "Tempura",
      "Udon (thick wheat noodles)",
      "Omurice (omelet rice)",
      "Salad"
    ]
  },
  {
    "id": "whale_evening_001",
    "pet_id": "whale",
    "time": "evening",
    "text_1_jp": "もうすっかり夜ラー\n\nでも、もうちょっとだけあそびたい気もするラー\n\n寝る前にちょっとだけ来て欲しいラー",
    "text_1_en": "It's already nighttime.\n\nBut I feel like I want to play with you just a little bit more.\n\nI want you to come over for a little while before you go to bed.",
    "text_2_jp": "今日もお疲れ様ラ！どんな一日だったラ？楽しかったことあったラ？",
    "text_2_en": "Good job today! How was your day? Did you have any fun?",
    "answers_2_jp": [
      "たのしかった",
      "いそがしかった",
      "ふつう",
      "うれしかった",
      "つかれた",
      "さいこう",
      "たいへん",
      "おもしろかった",
      "よかった",
      "ねてた"
    ],
    "answers_2_en": [
      "Fun",
      "Busy",
      "Normal",
      "Happy",
      "Tiring",
      "Great",
      "Tough",
      "Interesting",
      "Good",
      "Slept"
    ]
  },
  {
    "id": "giraffe_morning_001",
    "pet_id": "giraffe",
    "time": "morning",
    "text_1_jp": "{player_name}、おはようリン！\n\nおでかけのときには戸締まりを忘れずにリン！\n\n準備できたらあそびに来てリン！",
    "text_1_en": "Good morning, {player_name}!\n\nDon't forget to lock up when you go out!\n\nCome play when you're ready!",
    "text_2_jp": "おはようリン！今日は何をする予定リン？楽しみリンね！どこに行くリン？",
    "text_2_en": "Good morning! What are you planning to do today? I'm excited! Where are you going?",
    "answers_2_jp": [
      "えいが",
      "かいもの",
      "さんぽ",
      "しごと",
      "べんきょう",
      "うんどう",
      "やすみ",
      "りょこう",
      "りょうり",
      "どくしょ"
    ],
    "answers_2_en": [
      "Movie",
      "Shopping",
      "Walk",
      "Work",
      "Study",
      "Exercise",
      "Rest",
      "Travel",
      "Cooking",
      "Reading"
    ]
  },
  {
    "id": "giraffe_lunch_001",
    "pet_id": "giraffe",
    "time": "lunch",
    "text_1_jp": "お昼だリン！\n\n{pet_name}といっしょにあそぶリン！\n\nキャッキャッキャ！",
    "text_1_en": "It's lunch time!\n\nLet's play with me!\n\nCackel, cackle, cackle!",
    "text_2_jp": "お腹すいたリンー。お昼ご飯は何にするリン？おすすめ教えてリン！{player_name}は何が好きリン？",
    "text_2_en": "I'm hungry. What are you having for lunch? Tell me your recommendation! What do you like, {player_name}?",
    "answers_2_jp": [
      "かれー",
      "らーめん",
      "すし",
      "サンドイッチ",
      "ぱすた",
      "そば",
      "てんぷら",
      "うどん",
      "おむらいす",
      "さらだ"
    ],
    "answers_2_en": [
      "Curry",
      "Ramen",
      "Sushi",
      "Sandwich",
      "Pasta",
      "Soba (buckwheat noodles)",
      "Tempura",
      "Udon (thick wheat noodles)",
      "Omurice (omelet rice)",
      "Salad"
    ]
  },
  {
    "id": "giraffe_evening_001",
    "pet_id": "giraffe",
    "time": "evening",
    "text_1_jp": "今日もいーーっぱいあそんだリンねー！\n\n明日ももーーっといっぱあそんで欲しいリン！\n\nなんなら今からもう1回あそぶリン！",
    "text_1_en": "We had lots of fun today!\n\nI want to have lots more fun tomorrow!\n\nIf you want, we can play one more time now!",
    "text_2_jp": "今日もお疲れ様リン！どんな一日だったリン？楽しかったことあったリン？",
    "text_2_en": "Good job today! How was your day? Did you have any fun?",
    "answers_2_jp": [
      "たのしかった",
      "いそがしかった",
      "ふつう",
      "うれしかった",
      "つかれた",
      "さいこう",
      "たいへん",
      "おもしろかった",
      "よかった",
      "ねてた"
    ],
    "answers_2_en": [
      "Fun",
      "Busy",
      "Normal",
      "Happy",
      "Tiring",
      "Great",
      "Tough",
      "Interesting",
      "Good",
      "Slept"
    ]
  },
  {
    "id": "pinkdog_morning_001",
    "pet_id": "pinkdog",
    "time": "morning",
    "text_1_jp": "グッドモーニングだモコ！\n\n今日もとってもワンダフルな1日になる予感がするモコ！\n\nまずは{pet_name}とプレイトゥギャザーするモコ！",
    "text_1_en": "Good morning!\n\nI have a feeling it's going to be another very wonderful day here!\n\nLet's play with me together first of all!",
    "text_2_jp": "おはようモコ！今日は何をする予定モコ？楽しみモコね！どこに行くモコ？",
    "text_2_en": "Good morning! What are you planning to do today? I'm excited! Where are you going?",
    "answers_2_jp": [
      "えいが",
      "かいもの",
      "さんぽ",
      "しごと",
      "べんきょう",
      "うんどう",
      "やすみ",
      "りょこう",
      "りょうり",
      "どくしょ"
    ],
    "answers_2_en": [
      "Movie",
      "Shopping",
      "Walk",
      "Work",
      "Study",
      "Exercise",
      "Rest",
      "Travel",
      "Cooking",
      "Reading"
    ]
  },
  {
    "id": "pinkdog_lunch_001",
    "pet_id": "pinkdog",
    "time": "lunch",
    "text_1_jp": "ランチタイムだモコ！\n\nアフタヌーンをパワーマックスで迎えるためにも、\n\nまずは{pet_name}とプレイトゥギャザーするモコ！",
    "text_1_en": "It's lunch time!\n\nTo maximize your performance in the afternoon,\n\nlet's play with me together first of all!",
    "text_2_jp": "お腹すいたモコー。お昼ご飯は何にするモコ？おすすめ教えてモコ！{player_name}は何が好きモコ？",
    "text_2_en": "I'm hungry. What are you having for lunch? Tell me your recommendation! What do you like, {player_name}?",
    "answers_2_jp": [
      "かれー",
      "らーめん",
      "すし",
      "サンドイッチ",
      "ぱすた",
      "そば",
      "てんぷら",
      "うどん",
      "おむらいす",
      "さらだ"
    ],
    "answers_2_en": [
      "Curry",
      "Ramen",
      "Sushi",
      "Sandwich",
      "Pasta",
      "Soba (buckwheat noodles)",
      "Tempura",
      "Udon (thick wheat noodles)",
      "Omurice (omelet rice)",
      "Salad"
    ]
  },
  {
    "id": "pinkdog_evening_001",
    "pet_id": "pinkdog",
    "time": "evening",
    "text_1_jp": "今日もいっぱいプレイトゥギャザーしてくれてサンキューソーマッチモコ！\n\nえ、まだ遊び足りないモコ？\n\nしかたないからもう少しだけプレイトゥギャザーしてあげるモコ！",
    "text_1_en": "Thank you for playing with me today again.\n\nYou haven't played enough yet?\n\nOK. I can play with you a little bit more!",
    "text_2_jp": "今日もお疲れ様モコ！どんな一日だったモコ？楽しかったことあったモコ？",
    "text_2_en": "Good job today! How was your day? Did you have any fun?",
    "answers_2_jp": [
      "たのしかった",
      "いそがしかった",
      "ふつう",
      "うれしかった",
      "つかれた",
      "さいこう",
      "たいへん",
      "おもしろかった",
      "よかった",
      "ねてた"
    ],
    "answers_2_en": [
      "Fun",
      "Busy",
      "Normal",
      "Happy",
      "Tiring",
      "Great",
      "Tough",
      "Interesting",
      "Good",
      "Slept"
    ]
  },
  {
    "id": "panda_morning_001",
    "pet_id": "panda",
    "time": "morning",
    "text_1_jp": "おはよ〜パ〜！\n\n正直、あと20時間ぐらい寝られるパ〜\n\nでも、{player_name}とあそびたいからもう起きるパ〜",
    "text_1_en": "Good morning!\n\nHonestly, I can sleep 20 more hours.\n\nBut I'll get up to play with you!",
    "text_2_jp": "おはようパ！今日は何をする予定パ？楽しみパね！どこに行くパ？",
    "text_2_en": "Good morning! What are you planning to do today? I'm excited! Where are you going?",
    "answers_2_jp": [
      "えいが",
      "かいもの",
      "さんぽ",
      "しごと",
      "べんきょう",
      "うんどう",
      "やすみ",
      "りょこう",
      "りょうり",
      "どくしょ"
    ],
    "answers_2_en": [
      "Movie",
      "Shopping",
      "Walk",
      "Work",
      "Study",
      "Exercise",
      "Rest",
      "Travel",
      "Cooking",
      "Reading"
    ]
  },
  {
    "id": "panda_lunch_001",
    "pet_id": "panda",
    "time": "lunch",
    "text_1_jp": "お昼の時間パ〜\n\n別にお昼にこだわらなくても、1日中食べていられるパ〜\n\n{player_name}もご飯は後にして一緒にあそぶパ〜",
    "text_1_en": "It's lunch time!\n\nI can eat whole day regardless whether it's lunch time or not.\n\nYou should come and play with me right now.",
    "text_2_jp": "お腹すいたパー。お昼ご飯は何にするパ？おすすめ教えてパ！{player_name}は何が好きパ？",
    "text_2_en": "I'm hungry. What are you having for lunch? Tell me your recommendation! What do you like, {player_name}?",
    "answers_2_jp": [
      "かれー",
      "らーめん",
      "すし",
      "サンドイッチ",
      "ぱすた",
      "そば",
      "てんぷら",
      "うどん",
      "おむらいす",
      "さらだ"
    ],
    "answers_2_en": [
      "Curry",
      "Ramen",
      "Sushi",
      "Sandwich",
      "Pasta",
      "Soba (buckwheat noodles)",
      "Tempura",
      "Udon (thick wheat noodles)",
      "Omurice (omelet rice)",
      "Salad"
    ]
  },
  {
    "id": "panda_evening_001",
    "pet_id": "panda",
    "time": "evening",
    "text_1_jp": "今日もすっごく楽しかったパ〜\n\n主にごろごろしてただけパけど、良い1日だったパ〜\n\n今日の締めくくりに、一緒にあそぶパ〜",
    "text_1_en": "It was a very fun day again!\n\nI just laid around mostly though.\n\nTo end the day, let's play together!",
    "text_2_jp": "今日もお疲れ様パ！どんな一日だったパ？楽しかったことあったパ？",
    "text_2_en": "Good job today! How was your day? Did you have any fun?",
    "answers_2_jp": [
      "たのしかった",
      "いそがしかった",
      "ふつう",
      "うれしかった",
      "つかれた",
      "さいこう",
      "たいへん",
      "おもしろかった",
      "よかった",
      "ねてた"
    ],
    "answers_2_en": [
      "Fun",
      "Busy",
      "Normal",
      "Happy",
      "Tiring",
      "Great",
      "Tough",
      "Interesting",
      "Good",
      "Slept"
    ]
  },
  {
    "id": "dinosaur_morning_001",
    "pet_id": "dinosaur",
    "time": "morning",
    "text_1_jp": "{player_name}、おはよーノ\n\n{pet_name}は、今日も元気だノ\n\nおでかけ前に一緒のあそぼうノ！",
    "text_1_en": "Good morning, {player_name}!\n\nI'm doing very well today!\n\nLet's play together before you go out!",
    "text_2_jp": "おはようノ！今日は何をする予定ノ？楽しみノね！どこに行くノ？",
    "text_2_en": "Good morning! What are you planning to do today? I'm excited! Where are you going?",
    "answers_2_jp": [
      "えいが",
      "かいもの",
      "さんぽ",
      "しごと",
      "べんきょう",
      "うんどう",
      "やすみ",
      "りょこう",
      "りょうり",
      "どくしょ"
    ],
    "answers_2_en": [
      "Movie",
      "Shopping",
      "Walk",
      "Work",
      "Study",
      "Exercise",
      "Rest",
      "Travel",
      "Cooking",
      "Reading"
    ]
  },
  {
    "id": "dinosaur_lunch_001",
    "pet_id": "dinosaur",
    "time": "lunch",
    "text_1_jp": "{player_name}、お昼食べたノ？\n\nまだノ？\n\n{pet_name}、はやく一緒にあそびたいノ",
    "text_1_en": "Did you eat lunch yet, {player_name}?\n\nNot yet?\n\nI want to play with you soon!",
    "text_2_jp": "お腹すいたノー。お昼ご飯は何にするノ？おすすめ教えてノ！{player_name}は何が好きノ？",
    "text_2_en": "I'm hungry. What are you having for lunch? Tell me your recommendation! What do you like, {player_name}?",
    "answers_2_jp": [
      "かれー",
      "らーめん",
      "すし",
      "サンドイッチ",
      "ぱすた",
      "そば",
      "てんぷら",
      "うどん",
      "おむらいす",
      "さらだ"
    ],
    "answers_2_en": [
      "Curry",
      "Ramen",
      "Sushi",
      "Sandwich",
      "Pasta",
      "Soba (buckwheat noodles)",
      "Tempura",
      "Udon (thick wheat noodles)",
      "Omurice (omelet rice)",
      "Salad"
    ]
  },
  {
    "id": "dinosaur_evening_001",
    "pet_id": "dinosaur",
    "time": "evening",
    "text_1_jp": "もう夜だノー\n\n{player_name}はもう寝る時間なノ？\n\nまだ起きてるなら、一緒にあそぶノ！",
    "text_1_en": "It's night already.\n\nIs it bedtime for you already?\n\nIf not, let's play together a little bit more!",
    "text_2_jp": "今日もお疲れ様ノ！どんな一日だったノ？楽しかったことあったノ？",
    "text_2_en": "Good job today! How was your day? Did you have any fun?",
    "answers_2_jp": [
      "たのしかった",
      "いそがしかった",
      "ふつう",
      "うれしかった",
      "つかれた",
      "さいこう",
      "たいへん",
      "おもしろかった",
      "よかった",
      "ねてた"
    ],
    "answers_2_en": [
      "Fun",
      "Busy",
      "Normal",
      "Happy",
      "Tiring",
      "Great",
      "Tough",
      "Interesting",
      "Good",
      "Slept"
    ]
  },
  {
    "id": "penguin_morning_001",
    "pet_id": "penguin",
    "time": "morning",
    "text_1_jp": "おはよーペン！\n\n{player_name}、もう起きてるペン？\n\n起きてたらちょっとかまって欲しいペン",
    "text_1_en": "Good morning!\n\nAre you awake already...?\n\nPlease come and play with me if so.",
    "text_2_jp": "おはようペン！今日は何をする予定ペン？楽しみペンね！どこに行くペン？",
    "text_2_en": "Good morning! What are you planning to do today? I'm excited! Where are you going?",
    "answers_2_jp": [
      "えいが",
      "かいもの",
      "さんぽ",
      "しごと",
      "べんきょう",
      "うんどう",
      "やすみ",
      "りょこう",
      "りょうり",
      "どくしょ"
    ],
    "answers_2_en": [
      "Movie",
      "Shopping",
      "Walk",
      "Work",
      "Study",
      "Exercise",
      "Rest",
      "Travel",
      "Cooking",
      "Reading"
    ]
  },
  {
    "id": "penguin_lunch_001",
    "pet_id": "penguin",
    "time": "lunch",
    "text_1_jp": "お昼だペン！\n\nお昼なのに寒いとは、どういうことだペン？\n\nはやく遊びに来て欲しいペン！",
    "text_1_en": "It's lunch time!\n\nWhy is it so cold?\n\nPlease come and play with me soon!",
    "text_2_jp": "お腹すいたペンー。お昼ご飯は何にするペン？おすすめ教えてペン！{player_name}は何が好きペン？",
    "text_2_en": "I'm hungry. What are you having for lunch? Tell me your recommendation! What do you like, {player_name}?",
    "answers_2_jp": [
      "かれー",
      "らーめん",
      "すし",
      "サンドイッチ",
      "ぱすた",
      "そば",
      "てんぷら",
      "うどん",
      "おむらいす",
      "さらだ"
    ],
    "answers_2_en": [
      "Curry",
      "Ramen",
      "Sushi",
      "Sandwich",
      "Pasta",
      "Soba (buckwheat noodles)",
      "Tempura",
      "Udon (thick wheat noodles)",
      "Omurice (omelet rice)",
      "Salad"
    ]
  },
  {
    "id": "penguin_evening_001",
    "pet_id": "penguin",
    "time": "evening",
    "text_1_jp": "夜になったペンねー\n\n{player_name}、まだ起きてるペン？\n\n夜は暗くて寒いから、遊びに来て欲しいペン…",
    "text_1_en": "It's night already.\n\nAre you still awake, {player_name}...?\n\nIt's dak and cold outside. Please come and play with me...",
    "text_2_jp": "今日もお疲れ様ペン！どんな一日だったペン？楽しかったことあったペン？",
    "text_2_en": "Good job today! How was your day? Did you have any fun?",
    "answers_2_jp": [
      "たのしかった",
      "いそがしかった",
      "ふつう",
      "うれしかった",
      "つかれた",
      "さいこう",
      "たいへん",
      "おもしろかった",
      "よかった",
      "ねてた"
    ],
    "answers_2_en": [
      "Fun",
      "Busy",
      "Normal",
      "Happy",
      "Tiring",
      "Great",
      "Tough",
      "Interesting",
      "Good",
      "Slept"
    ]
  },
  {
    "id": "elephant_morning_001",
    "pet_id": "elephant",
    "time": "morning",
    "text_1_jp": "{player_name}、おはよーパオー\n\n{pet_name}は元気もりもりパオ！\n\n早く起きて一緒に遊ぶパオ！",
    "text_1_en": "Good morning, {player_name}!\n\nI'm doing very well today!\n\nLet's get up and play together soon!",
    "text_2_jp": "おはようパオ！今日は何をする予定パオ？楽しみパオね！どこに行くパオ？",
    "text_2_en": "Good morning! What are you planning to do today? I'm excited! Where are you going?",
    "answers_2_jp": [
      "えいが",
      "かいもの",
      "さんぽ",
      "しごと",
      "べんきょう",
      "うんどう",
      "やすみ",
      "りょこう",
      "りょうり",
      "どくしょ"
    ],
    "answers_2_en": [
      "Movie",
      "Shopping",
      "Walk",
      "Work",
      "Study",
      "Exercise",
      "Rest",
      "Travel",
      "Cooking",
      "Reading"
    ]
  },
  {
    "id": "elephant_lunch_001",
    "pet_id": "elephant",
    "time": "lunch",
    "text_1_jp": "お昼の時間だパオー\n\n{pet_name}、ちょっと大きめだから、ちょっとおなかすきやすいパオ…\n\nご飯食べさせに来て欲しいパオ…",
    "text_1_en": "It's lunch time!\n\nI'm a little bigger than others, so I become hungry soon...\n\nPlease come and give me some food...",
    "text_2_jp": "お腹すいたパオー。お昼ご飯は何にするパオ？おすすめ教えてパオ！{player_name}は何が好きパオ？",
    "text_2_en": "I'm hungry. What are you having for lunch? Tell me your recommendation! What do you like, {player_name}?",
    "answers_2_jp": [
      "かれー",
      "らーめん",
      "すし",
      "サンドイッチ",
      "ぱすた",
      "そば",
      "てんぷら",
      "うどん",
      "おむらいす",
      "さらだ"
    ],
    "answers_2_en": [
      "Curry",
      "Ramen",
      "Sushi",
      "Sandwich",
      "Pasta",
      "Soba (buckwheat noodles)",
      "Tempura",
      "Udon (thick wheat noodles)",
      "Omurice (omelet rice)",
      "Salad"
    ]
  },
  {
    "id": "elephant_evening_001",
    "pet_id": "elephant",
    "time": "evening",
    "text_1_jp": "あっという間に夜だパオ\n\n楽しいとあっという間に時間が経つパオ\n\nでも、まだまだ一緒に遊べるパオよね？",
    "text_1_en": "It's night already.\n\nTime flies when you're having fun.\n\nBut we can still play together, right?",
    "text_2_jp": "今日もお疲れ様パオ！どんな一日だったパオ？楽しかったことあったパオ？",
    "text_2_en": "Good job today! How was your day? Did you have any fun?",
    "answers_2_jp": [
      "たのしかった",
      "いそがしかった",
      "ふつう",
      "うれしかった",
      "つかれた",
      "さいこう",
      "たいへん",
      "おもしろかった",
      "よかった",
      "ねてた"
    ],
    "answers_2_en": [
      "Fun",
      "Busy",
      "Normal",
      "Happy",
      "Tiring",
      "Great",
      "Tough",
      "Interesting",
      "Good",
      "Slept"
    ]
  },
  {
    "id": "lion_morning_001",
    "pet_id": "lion",
    "time": "morning",
    "text_1_jp": "{player_name}、起きてるシ？\n\n{pet_name}、朝はゆっくり寝てたい派なんだけど、早くあそびたくて目が覚めちゃったシ\n\n早く一緒にあそぶシ！",
    "text_1_en": "Are you awake, {player_name}?\n\nI like to sleep in the morning, but I woke up early today because I wanted to play with you!\n\nLet's play together now!",
    "text_2_jp": "おはようシ！今日は何をする予定シ？楽しみシね！どこに行くシ？",
    "text_2_en": "Good morning! What are you planning to do today? I'm excited! Where are you going?",
    "answers_2_jp": [
      "えいが",
      "かいもの",
      "さんぽ",
      "しごと",
      "べんきょう",
      "うんどう",
      "やすみ",
      "りょこう",
      "りょうり",
      "どくしょ"
    ],
    "answers_2_en": [
      "Movie",
      "Shopping",
      "Walk",
      "Work",
      "Study",
      "Exercise",
      "Rest",
      "Travel",
      "Cooking",
      "Reading"
    ]
  },
  {
    "id": "lion_lunch_001",
    "pet_id": "lion",
    "time": "lunch",
    "text_1_jp": "{player_name}、お昼食べたシ？\n\n{pet_name}も、そろそろお昼食べてもいい年頃だシ\n\nごはんが待ち遠しいシ！",
    "text_1_en": "Did you eat lunch yet, {player_name}?\n\nI think it's a good time for me to have some lunch.\n\nCan't wait for it!",
    "text_2_jp": "お腹すいたシー。お昼ご飯は何にするシ？おすすめ教えてシ！{player_name}は何が好きシ？",
    "text_2_en": "I'm hungry. What are you having for lunch? Tell me your recommendation! What do you like, {player_name}?",
    "answers_2_jp": [
      "かれー",
      "らーめん",
      "すし",
      "サンドイッチ",
      "ぱすた",
      "そば",
      "てんぷら",
      "うどん",
      "おむらいす",
      "さらだ"
    ],
    "answers_2_en": [
      "Curry",
      "Ramen",
      "Sushi",
      "Sandwich",
      "Pasta",
      "Soba (buckwheat noodles)",
      "Tempura",
      "Udon (thick wheat noodles)",
      "Omurice (omelet rice)",
      "Salad"
    ]
  },
  {
    "id": "lion_evening_001",
    "pet_id": "lion",
    "time": "evening",
    "text_1_jp": "暗くなったシー\n\n夜はちょっと怖いシ…\n\n{player_name}、ちょっとあそびに来ないシ？",
    "text_1_en": "It's dark outside...\n\nI'm a little scared at night...\n\nDo you want to come and play with me a little bit?",
    "text_2_jp": "今日もお疲れ様シ！どんな一日だったシ？楽しかったことあったシ？",
    "text_2_en": "Good job today! How was your day? Did you have any fun?",
    "answers_2_jp": [
      "たのしかった",
      "いそがしかった",
      "ふつう",
      "うれしかった",
      "つかれた",
      "さいこう",
      "たいへん",
      "おもしろかった",
      "よかった",
      "ねてた"
    ],
    "answers_2_en": [
      "Fun",
      "Busy",
      "Normal",
      "Happy",
      "Tiring",
      "Great",
      "Tough",
      "Interesting",
      "Good",
      "Slept"
    ]
  },
  {
    "id": "reindeer_morning_001",
    "pet_id": "reindeer",
    "time": "morning",
    "text_1_jp": "{player_name}、早く起きて欲しいトナ！\n\n枕元にプレゼントがあるトナよ！\n\nまあ、それはかわいい嘘トナけど、起きたら一緒にあそぶトナ！",
    "text_1_en": "Wake up, {player_name}!\n\nThere's a present on your pillow!\n\nJoke aside, let's play together when you get up!",
    "text_2_jp": "おはようトナ！今日は何をする予定トナ？楽しみトナね！どこに行くトナ？",
    "text_2_en": "Good morning! What are you planning to do today? I'm excited! Where are you going?",
    "answers_2_jp": [
      "えいが",
      "かいもの",
      "さんぽ",
      "しごと",
      "べんきょう",
      "うんどう",
      "やすみ",
      "りょこう",
      "りょうり",
      "どくしょ"
    ],
    "answers_2_en": [
      "Movie",
      "Shopping",
      "Walk",
      "Work",
      "Study",
      "Exercise",
      "Rest",
      "Travel",
      "Cooking",
      "Reading"
    ]
  },
  {
    "id": "reindeer_lunch_001",
    "pet_id": "reindeer",
    "time": "lunch",
    "text_1_jp": "{player_name}、お昼の時間トナ！\n\n{pet_name}、ちょっとだけお腹すいてるトナ！\n\n{player_name}のごはんが済んだら、{pet_name}のごはんもお願いしたいトナ！",
    "text_1_en": "It's lunch time, {player_name}\n\nI'm a little bit hungry...!\n\nPlease come and give me some food after your lunch!",
    "text_2_jp": "お腹すいたトナー。お昼ご飯は何にするトナ？おすすめ教えてトナ！{player_name}は何が好きトナ？",
    "text_2_en": "I'm hungry. What are you having for lunch? Tell me your recommendation! What do you like, {player_name}?",
    "answers_2_jp": [
      "かれー",
      "らーめん",
      "すし",
      "サンドイッチ",
      "ぱすた",
      "そば",
      "てんぷら",
      "うどん",
      "おむらいす",
      "さらだ"
    ],
    "answers_2_en": [
      "Curry",
      "Ramen",
      "Sushi",
      "Sandwich",
      "Pasta",
      "Soba (buckwheat noodles)",
      "Tempura",
      "Udon (thick wheat noodles)",
      "Omurice (omelet rice)",
      "Salad"
    ]
  },
  {
    "id": "reindeer_evening_001",
    "pet_id": "reindeer",
    "time": "evening",
    "text_1_jp": "良い夜トナ…。\n\nこんな夜は、サンタが街にやってくるかもしれないトナ。\n\nサンタが来るまで、{pet_name}とあそんで待ってるといいトナ。",
    "text_1_en": "It's a very good night...\n\nOn a night like this, Santa might come to town.\n\nYou can play with me and wait until Santa comes.",
    "text_2_jp": "今日もお疲れ様トナ！どんな一日だったトナ？楽しかったことあったトナ？",
    "text_2_en": "Good job today! How was your day? Did you have any fun?",
    "answers_2_jp": [
      "たのしかった",
      "いそがしかった",
      "ふつう",
      "うれしかった",
      "つかれた",
      "さいこう",
      "たいへん",
      "おもしろかった",
      "よかった",
      "ねてた"
    ],
    "answers_2_en": [
      "Fun",
      "Busy",
      "Normal",
      "Happy",
      "Tiring",
      "Great",
      "Tough",
      "Interesting",
      "Good",
      "Slept"
    ]
  },
  {
    "id": "polarbear_morning_001",
    "pet_id": "polarbear",
    "time": "morning",
    "text_1_jp": "{player_name}、おはよーポラ〜。\n\nもう起きてるポラ？まだ寝てるポラ？\n\nどっちでもいいから、一緒にあそんで欲しいポラ〜",
    "text_1_en": "Good morning, {player_name}!\n\nAre you awake already...? Or are you still asleep?\n\nEither way, I want you to play with me!",
    "text_2_jp": "おはようポラ！今日は何をする予定ポラ？楽しみポラね！どこに行くポラ？",
    "text_2_en": "Good morning! What are you planning to do today? I'm excited! Where are you going?",
    "answers_2_jp": [
      "えいが",
      "かいもの",
      "さんぽ",
      "しごと",
      "べんきょう",
      "うんどう",
      "やすみ",
      "りょこう",
      "りょうり",
      "どくしょ"
    ],
    "answers_2_en": [
      "Movie",
      "Shopping",
      "Walk",
      "Work",
      "Study",
      "Exercise",
      "Rest",
      "Travel",
      "Cooking",
      "Reading"
    ]
  },
  {
    "id": "polarbear_lunch_001",
    "pet_id": "polarbear",
    "time": "lunch",
    "text_1_jp": "{player_name}、お昼休みポラ〜。\n\nお昼はしっかり食べたほうがいいポラ！\n\nそしたら、{pet_name}としっかりあそべるポラ！",
    "text_1_en": "It's lunch time, {player_name}\n\nYou should eat a good lunch!\n\nThen you can play a lot with me!",
    "text_2_jp": "お腹すいたポラー。お昼ご飯は何にするポラ？おすすめ教えてポラ！{player_name}は何が好きポラ？",
    "text_2_en": "I'm hungry. What are you having for lunch? Tell me your recommendation! What do you like, {player_name}?",
    "answers_2_jp": [
      "かれー",
      "らーめん",
      "すし",
      "サンドイッチ",
      "ぱすた",
      "そば",
      "てんぷら",
      "うどん",
      "おむらいす",
      "さらだ"
    ],
    "answers_2_en": [
      "Curry",
      "Ramen",
      "Sushi",
      "Sandwich",
      "Pasta",
      "Soba (buckwheat noodles)",
      "Tempura",
      "Udon (thick wheat noodles)",
      "Omurice (omelet rice)",
      "Salad"
    ]
  },
  {
    "id": "polarbear_evening_001",
    "pet_id": "polarbear",
    "time": "evening",
    "text_1_jp": "{player_name}、もう寝ちゃったポラ？\n\nそれとも、まだ起きてるポラ？\n\nどっちでもいいから、一緒にあそんで欲しいポラ〜",
    "text_1_en": "{player_name}, are you sleeping already?\n\nOr, are you still awake?\n\nEither way, I want you to play with me!",
    "text_2_jp": "今日もお疲れ様ポラ！どんな一日だったポラ？楽しかったことあったポラ？",
    "text_2_en": "Good job today! How was your day? Did you have any fun?",
    "answers_2_jp": [
      "たのしかった",
      "いそがしかった",
      "ふつう",
      "うれしかった",
      "つかれた",
      "さいこう",
      "たいへん",
      "おもしろかった",
      "よかった",
      "ねてた"
    ],
    "answers_2_en": [
      "Fun",
      "Busy",
      "Normal",
      "Happy",
      "Tiring",
      "Great",
      "Tough",
      "Interesting",
      "Good",
      "Slept"
    ]
  },
  {
    "id": "alpaca_morning_001",
    "pet_id": "alpaca",
    "time": "morning",
    "text_1_jp": "おはようパカ〜。\n\n朝起きたらすぐにベッドメイクをすると、幸福度が上がるらしいパカ。\n\nそのあと{pet_name}とあそぶと、さらに幸福度が上がるらしいパカ。",
    "text_1_en": "Good morning!\n\nThey say that making the bed as soon as you wake up in the morning increases happiness.\n\nPlaying with me after that increases happiness even more.",
    "text_2_jp": "おはようパカ！今日は何をする予定パカ？楽しみパカね！どこに行くパカ？",
    "text_2_en": "Good morning! What are you planning to do today? I'm excited! Where are you going?",
    "answers_2_jp": [
      "えいが",
      "かいもの",
      "さんぽ",
      "しごと",
      "べんきょう",
      "うんどう",
      "やすみ",
      "りょこう",
      "りょうり",
      "どくしょ"
    ],
    "answers_2_en": [
      "Movie",
      "Shopping",
      "Walk",
      "Work",
      "Study",
      "Exercise",
      "Rest",
      "Travel",
      "Cooking",
      "Reading"
    ]
  },
  {
    "id": "alpaca_lunch_001",
    "pet_id": "alpaca",
    "time": "lunch",
    "text_1_jp": "{player_name}、お昼パカね〜。\n\nお昼といえばお昼ごはんを食べがちだけど、お昼に晩ごはんを食べたっていいと思うパカ。\n\nいや、それはないパカね。",
    "text_1_en": "It's lunch time, {player_name}\n\nWe tend to eat lunch at noon, but I think it's okay to eat dinner for lunch.\n\nNo, that's not true.",
    "text_2_jp": "お腹すいたパカー。お昼ご飯は何にするパカ？おすすめ教えてパカ！{player_name}は何が好きパカ？",
    "text_2_en": "I'm hungry. What are you having for lunch? Tell me your recommendation! What do you like, {player_name}?",
    "answers_2_jp": [
      "かれー",
      "らーめん",
      "すし",
      "サンドイッチ",
      "ぱすた",
      "そば",
      "てんぷら",
      "うどん",
      "おむらいす",
      "さらだ"
    ],
    "answers_2_en": [
      "Curry",
      "Ramen",
      "Sushi",
      "Sandwich",
      "Pasta",
      "Soba (buckwheat noodles)",
      "Tempura",
      "Udon (thick wheat noodles)",
      "Omurice (omelet rice)",
      "Salad"
    ]
  },
  {
    "id": "alpaca_evening_001",
    "pet_id": "alpaca",
    "time": "evening",
    "text_1_jp": "{player_name}、今日も楽しかったパカね。\n\nまた明日も一緒に遊んでくれるパカ？\n\nてことは、今すぐ一緒に遊んでくれるパカ？そういうことパカ？",
    "text_1_en": "{player_name}, it was a great day again!\n\nWill you play with me again tomorrow?\n\nSo, will you play with me now? Is that what you mean?",
    "text_2_jp": "今日もお疲れ様パカ！どんな一日だったパカ？楽しかったことあったパカ？",
    "text_2_en": "Good job today! How was your day? Did you have any fun?",
    "answers_2_jp": [
      "たのしかった",
      "いそがしかった",
      "ふつう",
      "うれしかった",
      "つかれた",
      "さいこう",
      "たいへん",
      "おもしろかった",
      "よかった",
      "ねてた"
    ],
    "answers_2_en": [
      "Fun",
      "Busy",
      "Normal",
      "Happy",
      "Tiring",
      "Great",
      "Tough",
      "Interesting",
      "Good",
      "Slept"
    ]
  },
  {
    "id": "tiger_morning_001",
    "pet_id": "tiger",
    "time": "morning",
    "text_1_jp": "おはようさんトラ〜。\n突然だけど、{player_name}の今日の運勢は。。。\n\nこ、これは！トラ！\n\n続きが知りたかったら、{pet_name}のところに遊びに来るトラ！",
    "text_1_en": "Good morning! So, your fortune today is...\n\nWh, what!?\n\nIf you want to know the result, come visit me now!",
    "text_2_jp": "おはようトラ！今日は何をする予定トラ？楽しみトラね！どこに行くトラ？",
    "text_2_en": "Good morning! What are you planning to do today? I'm excited! Where are you going?",
    "answers_2_jp": [
      "えいが",
      "かいもの",
      "さんぽ",
      "しごと",
      "べんきょう",
      "うんどう",
      "やすみ",
      "りょこう",
      "りょうり",
      "どくしょ"
    ],
    "answers_2_en": [
      "Movie",
      "Shopping",
      "Walk",
      "Work",
      "Study",
      "Exercise",
      "Rest",
      "Travel",
      "Cooking",
      "Reading"
    ]
  },
  {
    "id": "tiger_lunch_001",
    "pet_id": "tiger",
    "time": "lunch",
    "text_1_jp": "{player_name}、お昼トラよ〜。\n\n{pet_name}、おなかがすき過ぎてシマシマが残り2本になっちゃったトラ！\n\nそういう仕組みなのトラ。",
    "text_1_en": "It's lunch time, {player_name}\n\nI'm so hungry I only have two stripes left.\n\nYeah, that's how it works.",
    "text_2_jp": "お腹すいたトラー。お昼ご飯は何にするトラ？おすすめ教えてトラ！{player_name}は何が好きトラ？",
    "text_2_en": "I'm hungry. What are you having for lunch? Tell me your recommendation! What do you like, {player_name}?",
    "answers_2_jp": [
      "かれー",
      "らーめん",
      "すし",
      "サンドイッチ",
      "ぱすた",
      "そば",
      "てんぷら",
      "うどん",
      "おむらいす",
      "さらだ"
    ],
    "answers_2_en": [
      "Curry",
      "Ramen",
      "Sushi",
      "Sandwich",
      "Pasta",
      "Soba (buckwheat noodles)",
      "Tempura",
      "Udon (thick wheat noodles)",
      "Omurice (omelet rice)",
      "Salad"
    ]
  },
  {
    "id": "tiger_evening_001",
    "pet_id": "tiger",
    "time": "evening",
    "text_1_jp": "{player_name}、今日もいっぱ遊んでくれたトラね〜。\n\nお礼に{player_name}の明日の運勢を占ってあげるトラ。。。こ、これは！トラ！\n\n続きが知りたかったら、{pet_name}のところに遊びに来るトラ！",
    "text_1_en": "{player_name}, thank you for playing with me alot again!\n\nIn return, I will read your fortune tomorrow. Wh, whaaaaat!?\n\nIf you want to know the result, come visit me now!",
    "text_2_jp": "今日もお疲れ様トラ！どんな一日だったトラ？楽しかったことあったトラ？",
    "text_2_en": "Good job today! How was your day? Did you have any fun?",
    "answers_2_jp": [
      "たのしかった",
      "いそがしかった",
      "ふつう",
      "うれしかった",
      "つかれた",
      "さいこう",
      "たいへん",
      "おもしろかった",
      "よかった",
      "ねてた"
    ],
    "answers_2_en": [
      "Fun",
      "Busy",
      "Normal",
      "Happy",
      "Tiring",
      "Great",
      "Tough",
      "Interesting",
      "Good",
      "Slept"
    ]
  },
  {
    "id": "sealion_morning_001",
    "pet_id": "sealion",
    "time": "morning",
    "text_1_jp": "んー。よく寝たラシ〜。\n\n{player_name}もよく寝られたラシか？\n\nおでかけ前に、ちょっとだけ{pet_name}とあそんでほしいラシ！",
    "text_1_en": "Hmmm. Slept very well.\n\nDid you sleep well too, {player_name}?\n\nI want you to play with me for a minute before you go out!",
    "text_2_jp": "おはようラシ！今日は何をする予定ラシ？楽しみラシね！どこに行くラシ？",
    "text_2_en": "Good morning! What are you planning to do today? I'm excited! Where are you going?",
    "answers_2_jp": [
      "えいが",
      "かいもの",
      "さんぽ",
      "しごと",
      "べんきょう",
      "うんどう",
      "やすみ",
      "りょこう",
      "りょうり",
      "どくしょ"
    ],
    "answers_2_en": [
      "Movie",
      "Shopping",
      "Walk",
      "Work",
      "Study",
      "Exercise",
      "Rest",
      "Travel",
      "Cooking",
      "Reading"
    ]
  },
  {
    "id": "sealion_lunch_001",
    "pet_id": "sealion",
    "time": "lunch",
    "text_1_jp": "あっという間にお昼ラシ！\n\n今日は一緒にお昼食べるられるラシ？\n\nおかずの交換っことかするラシ！",
    "text_1_en": "It's noon!\n\nCan we have lunch together today?\n\nLet's trade side dishes!",
    "text_2_jp": "お腹すいたラシー。お昼ご飯は何にするラシ？おすすめ教えてラシ！{player_name}は何が好きラシ？",
    "text_2_en": "I'm hungry. What are you having for lunch? Tell me your recommendation! What do you like, {player_name}?",
    "answers_2_jp": [
      "かれー",
      "らーめん",
      "すし",
      "サンドイッチ",
      "ぱすた",
      "そば",
      "てんぷら",
      "うどん",
      "おむらいす",
      "さらだ"
    ],
    "answers_2_en": [
      "Curry",
      "Ramen",
      "Sushi",
      "Sandwich",
      "Pasta",
      "Soba (buckwheat noodles)",
      "Tempura",
      "Udon (thick wheat noodles)",
      "Omurice (omelet rice)",
      "Salad"
    ]
  },
  {
    "id": "sealion_evening_001",
    "pet_id": "sealion",
    "time": "evening",
    "text_1_jp": "{player_name}、今日も楽しかったラシね〜。\n\nもう寝るラシ？まだ寝ないラシ？\n\nまだ寝ないなら、ちょっとあそびに来て欲しいラシ！",
    "text_1_en": "{player_name}, it was a great day again!\n\nAre you going to sleep now? Not yet?\n\nIf you haven't gone to bed yet, I'd love for you to come play with me for a bit!",
    "text_2_jp": "今日もお疲れ様ラシ！どんな一日だったラシ？楽しかったことあったラシ？",
    "text_2_en": "Good job today! How was your day? Did you have any fun?",
    "answers_2_jp": [
      "たのしかった",
      "いそがしかった",
      "ふつう",
      "うれしかった",
      "つかれた",
      "さいこう",
      "たいへん",
      "おもしろかった",
      "よかった",
      "ねてた"
    ],
    "answers_2_en": [
      "Fun",
      "Busy",
      "Normal",
      "Happy",
      "Tiring",
      "Great",
      "Tough",
      "Interesting",
      "Good",
      "Slept"
    ]
  },
  {
    "id": "flamingo_morning_001",
    "pet_id": "flamingo",
    "time": "morning",
    "text_1_jp": "グッドモーニンゴ♪\n\n新しい1日のはじまりンゴ！\n\n早速、{pet_name}のお部屋に遊びにきてほしいンゴ★",
    "text_1_en": "Good morning!\n\nIt's the start of a new day!\n\nI want you to come and play in my room!",
    "text_2_jp": "おはようンゴ！今日は何をする予定ンゴ？楽しみンゴね！どこに行くンゴ？",
    "text_2_en": "Good morning! What are you planning to do today? I'm excited! Where are you going?",
    "answers_2_jp": [
      "えいが",
      "かいもの",
      "さんぽ",
      "しごと",
      "べんきょう",
      "うんどう",
      "やすみ",
      "りょこう",
      "りょうり",
      "どくしょ"
    ],
    "answers_2_en": [
      "Movie",
      "Shopping",
      "Walk",
      "Work",
      "Study",
      "Exercise",
      "Rest",
      "Travel",
      "Cooking",
      "Reading"
    ]
  },
  {
    "id": "flamingo_lunch_001",
    "pet_id": "flamingo",
    "time": "lunch",
    "text_1_jp": "ランチタイムンゴ♪\n\n今日のランチは何にするンゴ？\n\n{pet_name}のごはんも忘れずにお願いするンゴ！",
    "text_1_en": "It's lunch time!\n\nWhat's your lunch today?\n\nDon't forget to feed me too!",
    "text_2_jp": "お腹すいたンゴー。お昼ご飯は何にするンゴ？おすすめ教えてンゴ！{player_name}は何が好きンゴ？",
    "text_2_en": "I'm hungry. What are you having for lunch? Tell me your recommendation! What do you like, {player_name}?",
    "answers_2_jp": [
      "かれー",
      "らーめん",
      "すし",
      "サンドイッチ",
      "ぱすた",
      "そば",
      "てんぷら",
      "うどん",
      "おむらいす",
      "さらだ"
    ],
    "answers_2_en": [
      "Curry",
      "Ramen",
      "Sushi",
      "Sandwich",
      "Pasta",
      "Soba (buckwheat noodles)",
      "Tempura",
      "Udon (thick wheat noodles)",
      "Omurice (omelet rice)",
      "Salad"
    ]
  },
  {
    "id": "flamingo_evening_001",
    "pet_id": "flamingo",
    "time": "evening",
    "text_1_jp": "グッドイブニンゴ♪\n\n今日もおつかれンゴ！\n\n1日のシメに{pet_name}と遊ぶンゴ！",
    "text_1_en": "Good evening!\n\nHow was your day?\n\nPlay with me at the end of the day!",
    "text_2_jp": "今日もお疲れ様ンゴ！どんな一日だったンゴ？楽しかったことあったンゴ？",
    "text_2_en": "Good job today! How was your day? Did you have any fun?",
    "answers_2_jp": [
      "たのしかった",
      "いそがしかった",
      "ふつう",
      "うれしかった",
      "つかれた",
      "さいこう",
      "たいへん",
      "おもしろかった",
      "よかった",
      "ねてた"
    ],
    "answers_2_en": [
      "Fun",
      "Busy",
      "Normal",
      "Happy",
      "Tiring",
      "Great",
      "Tough",
      "Interesting",
      "Good",
      "Slept"
    ]
  },
  {
    "id": "cow_morning_001",
    "pet_id": "cow",
    "time": "morning",
    "text_1_jp": "{player_name}、おはようウシ〜。\n\n良い夢見たウシ？{pet_name}はかなり良い夢を見た気がするウシ！\n\nあ。。。いま急速に忘れちゃったウシ(泣)",
    "text_1_en": "Good morning!\n\nDid you have a good dream? I think I had a pretty good dream!\n\nAh... I suddenly forgot it...",
    "text_2_jp": "おはようウシ！今日は何をする予定ウシ？楽しみウシね！どこに行くウシ？",
    "text_2_en": "Good morning! What are you planning to do today? I'm excited! Where are you going?",
    "answers_2_jp": [
      "えいが",
      "かいもの",
      "さんぽ",
      "しごと",
      "べんきょう",
      "うんどう",
      "やすみ",
      "りょこう",
      "りょうり",
      "どくしょ"
    ],
    "answers_2_en": [
      "Movie",
      "Shopping",
      "Walk",
      "Work",
      "Study",
      "Exercise",
      "Rest",
      "Travel",
      "Cooking",
      "Reading"
    ]
  },
  {
    "id": "cow_lunch_001",
    "pet_id": "cow",
    "time": "lunch",
    "text_1_jp": "{player_name}、お昼だウシ〜。\n\nお昼といえば給食、給食といえばもちろん牛乳だウシね！\n\n小学生男子は牛乳の早飲みに命を賭けがちだけど、本当はゆっくり味わって飲むのがいいウシ！",
    "text_1_en": "It's lunch time, {player_name}\n\nLunch means school lunches, and school lunches mean, of course, milk!\n\nElementary school boys tend to bet their lives on drinking milk too fast, but the truth is, you should drink it slowly and savor it!",
    "text_2_jp": "お腹すいたウシー。お昼ご飯は何にするウシ？おすすめ教えてウシ！{player_name}は何が好きウシ？",
    "text_2_en": "I'm hungry. What are you having for lunch? Tell me your recommendation! What do you like, {player_name}?",
    "answers_2_jp": [
      "かれー",
      "らーめん",
      "すし",
      "サンドイッチ",
      "ぱすた",
      "そば",
      "てんぷら",
      "うどん",
      "おむらいす",
      "さらだ"
    ],
    "answers_2_en": [
      "Curry",
      "Ramen",
      "Sushi",
      "Sandwich",
      "Pasta",
      "Soba (buckwheat noodles)",
      "Tempura",
      "Udon (thick wheat noodles)",
      "Omurice (omelet rice)",
      "Salad"
    ]
  },
  {
    "id": "cow_evening_001",
    "pet_id": "cow",
    "time": "evening",
    "text_1_jp": "今日もいっぱいあそんだウシ。\n\n今日も良い夢見られるウシかね〜？\n\n寝る前に{pet_name}とあそぶと、良い夢が見られるらしいウシよ！",
    "text_1_en": "We played a lot today!\n\nI hope we have a good dream again tonight.\n\nThey say if you play with me before you go to bed, you'll have good dreams!",
    "text_2_jp": "今日もお疲れ様ウシ！どんな一日だったウシ？楽しかったことあったウシ？",
    "text_2_en": "Good job today! How was your day? Did you have any fun?",
    "answers_2_jp": [
      "たのしかった",
      "いそがしかった",
      "ふつう",
      "うれしかった",
      "つかれた",
      "さいこう",
      "たいへん",
      "おもしろかった",
      "よかった",
      "ねてた"
    ],
    "answers_2_en": [
      "Fun",
      "Busy",
      "Normal",
      "Happy",
      "Tiring",
      "Great",
      "Tough",
      "Interesting",
      "Good",
      "Slept"
    ]
  },
  {
    "id": "squirrel_morning_001",
    "pet_id": "squirrel",
    "time": "morning",
    "text_1_jp": "おはようッス！朝ッスね！\n\n朝のランニングタイムッス！\n\n一緒にどうッスか？",
    "text_1_en": "Hey! Rise and shine!\n\nTime for my morning run!\n\nWould you like to join me?",
    "text_2_jp": "おはようッス！今日は何をする予定ッス？楽しみッスね！どこに行くッス？",
    "text_2_en": "Good morning! What are you planning to do today? I'm excited! Where are you going?",
    "answers_2_jp": [
      "えいが",
      "かいもの",
      "さんぽ",
      "しごと",
      "べんきょう",
      "うんどう",
      "やすみ",
      "りょこう",
      "りょうり",
      "どくしょ"
    ],
    "answers_2_en": [
      "Movie",
      "Shopping",
      "Walk",
      "Work",
      "Study",
      "Exercise",
      "Rest",
      "Travel",
      "Cooking",
      "Reading"
    ]
  },
  {
    "id": "squirrel_lunch_001",
    "pet_id": "squirrel",
    "time": "lunch",
    "text_1_jp": "おいッス！{pet_name}ッス！\n\nお昼を食べて筋トレに励むッス！\n\nまずはお昼ごはんをお願いしたいッス！",
    "text_1_en": "Hey! Here I am!!\n\nIt's time for lunch and some muscle training!\n\nI'd like to have lunch first!",
    "text_2_jp": "お腹すいたッスー。お昼ご飯は何にするッス？おすすめ教えてッス！{player_name}は何が好きッス？",
    "text_2_en": "I'm hungry. What are you having for lunch? Tell me your recommendation! What do you like, {player_name}?",
    "answers_2_jp": [
      "かれー",
      "らーめん",
      "すし",
      "サンドイッチ",
      "ぱすた",
      "そば",
      "てんぷら",
      "うどん",
      "おむらいす",
      "さらだ"
    ],
    "answers_2_en": [
      "Curry",
      "Ramen",
      "Sushi",
      "Sandwich",
      "Pasta",
      "Soba (buckwheat noodles)",
      "Tempura",
      "Udon (thick wheat noodles)",
      "Omurice (omelet rice)",
      "Salad"
    ]
  },
  {
    "id": "squirrel_evening_001",
    "pet_id": "squirrel",
    "time": "evening",
    "text_1_jp": "こんばんわッス！今日も1日お疲れッス！\n\n寝る前に締めのトレーニングッス！\n\n汗かいたので、おふろ入れてくれないッス？",
    "text_1_en": "Hey! That was a long day!\n\nIt's time for a end-of-day workout before bed!\n\nI'm sweating so much, can you take me to the bath?",
    "text_2_jp": "今日もお疲れ様ッス！どんな一日だったッス？楽しかったことあったッス？",
    "text_2_en": "Good job today! How was your day? Did you have any fun?",
    "answers_2_jp": [
      "たのしかった",
      "いそがしかった",
      "ふつう",
      "うれしかった",
      "つかれた",
      "さいこう",
      "たいへん",
      "おもしろかった",
      "よかった",
      "ねてた"
    ],
    "answers_2_en": [
      "Fun",
      "Busy",
      "Normal",
      "Happy",
      "Tiring",
      "Great",
      "Tough",
      "Interesting",
      "Good",
      "Slept"
    ]
  },
  {
    "id": "persiancat_morning_001",
    "pet_id": "persiancat",
    "time": "morning",
    "text_1_jp": "お早いお目覚めペル\n\n昨夜はよくお休みになれましてペル？\n\nよろしかったら、わたくしのおへやに寄ってらしてペル",
    "text_1_en": "You are an early riser.\n\nI hope you had a good night's rest last night.\n\nIf you like, you can drop by my place for a while.",
    "text_2_jp": "おはようベル！今日は何をする予定ベル？楽しみベルね！どこに行くベル？",
    "text_2_en": "Good morning! What are you planning to do today? I'm excited! Where are you going?",
    "answers_2_jp": [
      "えいが",
      "かいもの",
      "さんぽ",
      "しごと",
      "べんきょう",
      "うんどう",
      "やすみ",
      "りょこう",
      "りょうり",
      "どくしょ"
    ],
    "answers_2_en": [
      "Movie",
      "Shopping",
      "Walk",
      "Work",
      "Study",
      "Exercise",
      "Rest",
      "Travel",
      "Cooking",
      "Reading"
    ]
  },
  {
    "id": "persiancat_lunch_001",
    "pet_id": "persiancat",
    "time": "lunch",
    "text_1_jp": "ごきげんようペル\n\n早いもので、もうランチタイムペル\n\nよろしかったら、ご一緒にランチはいかがペル？",
    "text_1_en": "How are you doing?\n\nIt's already lunch time.\n\nWould you like to have lunch with me?",
    "text_2_jp": "お腹すいたベルー。お昼ご飯は何にするベル？おすすめ教えてベル！{player_name}は何が好きベル？",
    "text_2_en": "I'm hungry. What are you having for lunch? Tell me your recommendation! What do you like, {player_name}?",
    "answers_2_jp": [
      "かれー",
      "らーめん",
      "すし",
      "サンドイッチ",
      "ぱすた",
      "そば",
      "てんぷら",
      "うどん",
      "おむらいす",
      "さらだ"
    ],
    "answers_2_en": [
      "Curry",
      "Ramen",
      "Sushi",
      "Sandwich",
      "Pasta",
      "Soba (buckwheat noodles)",
      "Tempura",
      "Udon (thick wheat noodles)",
      "Omurice (omelet rice)",
      "Salad"
    ]
  },
  {
    "id": "persiancat_evening_001",
    "pet_id": "persiancat",
    "time": "evening",
    "text_1_jp": "ステキな夜ペルね\n\nそろそろご就寝されるペル？\n\nその前に少し、わたくしとパジャマトークでもいかがペル？",
    "text_1_en": "It's a beautiful night.\n\nAre you going to bed soon?\n\nHow about a little pajama talk with me?",
    "text_2_jp": "今日もお疲れ様ベル！どんな一日だったベル？楽しかったことあったベル？",
    "text_2_en": "Good job today! How was your day? Did you have any fun?",
    "answers_2_jp": [
      "たのしかった",
      "いそがしかった",
      "ふつう",
      "うれしかった",
      "つかれた",
      "さいこう",
      "たいへん",
      "おもしろかった",
      "よかった",
      "ねてた"
    ],
    "answers_2_en": [
      "Fun",
      "Busy",
      "Normal",
      "Happy",
      "Tiring",
      "Great",
      "Tough",
      "Interesting",
      "Good",
      "Slept"
    ]
  },
  {
    "id": "dolphin_morning_001",
    "pet_id": "dolphin",
    "time": "morning",
    "text_1_jp": "おっはーフィン！\n\n今日も1日はりきっていくフィン！\n\nまずは{pet_name}のおへやによってかないフィン？",
    "text_1_en": "Good morning!\n\nLet's get going for a new day!\n\nWhy don't you stop by my room, first?",
    "text_2_jp": "おはようフィン！今日は何をする予定フィン？楽しみフィンね！どこに行くフィン？",
    "text_2_en": "Good morning! What are you planning to do today? I'm excited! Where are you going?",
    "answers_2_jp": [
      "えいが",
      "かいもの",
      "さんぽ",
      "しごと",
      "べんきょう",
      "うんどう",
      "やすみ",
      "りょこう",
      "りょうり",
      "どくしょ"
    ],
    "answers_2_en": [
      "Movie",
      "Shopping",
      "Walk",
      "Work",
      "Study",
      "Exercise",
      "Rest",
      "Travel",
      "Cooking",
      "Reading"
    ]
  },
  {
    "id": "dolphin_lunch_001",
    "pet_id": "dolphin",
    "time": "lunch",
    "text_1_jp": "ハロハロ〜フィン！\n\nそろそろランチタイムフィン？\n\n{pet_name}の分も忘れずに頼むフィン！",
    "text_1_en": "Hello, hello~!\n\nIs it time for lunch?\n\nDon't forget to bring some for me!",
    "text_2_jp": "お腹すいたフィンー。お昼ご飯は何にするフィン？おすすめ教えてフィン！{player_name}は何が好きフィン？",
    "text_2_en": "I'm hungry. What are you having for lunch? Tell me your recommendation! What do you like, {player_name}?",
    "answers_2_jp": [
      "かれー",
      "らーめん",
      "すし",
      "サンドイッチ",
      "ぱすた",
      "そば",
      "てんぷら",
      "うどん",
      "おむらいす",
      "さらだ"
    ],
    "answers_2_en": [
      "Curry",
      "Ramen",
      "Sushi",
      "Sandwich",
      "Pasta",
      "Soba (buckwheat noodles)",
      "Tempura",
      "Udon (thick wheat noodles)",
      "Omurice (omelet rice)",
      "Salad"
    ]
  },
  {
    "id": "dolphin_evening_001",
    "pet_id": "dolphin",
    "time": "evening",
    "text_1_jp": "パーリナイ★フィン！\n\n...って、そろそろベッドタイムフィン？\n\nお休みの前に{pet_name}とひと遊びしていくフィン！",
    "text_1_en": "It's party time!\n\nOr time for bed?\n\nHave some fun with me before you go to sleep!",
    "text_2_jp": "今日もお疲れ様フィン！どんな一日だったフィン？楽しかったことあったフィン？",
    "text_2_en": "Good job today! How was your day? Did you have any fun?",
    "answers_2_jp": [
      "たのしかった",
      "いそがしかった",
      "ふつう",
      "うれしかった",
      "つかれた",
      "さいこう",
      "たいへん",
      "おもしろかった",
      "よかった",
      "ねてた"
    ],
    "answers_2_en": [
      "Fun",
      "Busy",
      "Normal",
      "Happy",
      "Tiring",
      "Great",
      "Tough",
      "Interesting",
      "Good",
      "Slept"
    ]
  }
]
